import { render, staticRenderFns } from "./firstPage.vue?vue&type=template&id=05e48d12&scoped=true&"
import script from "./firstPage.vue?vue&type=script&lang=js&"
export * from "./firstPage.vue?vue&type=script&lang=js&"
import style0 from "./firstPage.vue?vue&type=style&index=0&id=05e48d12&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05e48d12",
  null
  
)

export default component.exports